<template>
  <PageLayout class="news-page">
    <PageTitle class="page-title">Новини</PageTitle>
    <Breadcrumbs :breadcrumbs="breadcrumbs"/>
    <Divider type="horizontal" />
    <NewsList />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import NewsList from '../../views/news/list.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
import {Divider} from "@/shared/ui/divider";
import Breadcrumbs from "@/shared/ui/breadcrumbs/breadcrumbs/index.vue";

export default {
  created() {
    this.changeActivePage(pages.RESOURCES);
  },
  components: {Divider, Breadcrumbs, PageLayout, PageTitle, NewsList },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: 'Головна',
        },
        {
          title: 'Ресурси',
        },
        {
          title: 'Новини'
        },
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  margin-bottom: 8px !important;
}

/*::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}*/
</style>
